import React from 'react';
import { useParams } from 'react-router-dom';

import { Text } from '../atoms/Text';
import { Heading } from '../atoms/Heading';
import { Field } from '../molecules/Field';

import { InfoCard } from '../../components/molecules/InfoCard';
import Illustration from '../molecules/Illustration';

function TechniqueForm({ options }) {
    let { pathway } = useParams();

    let know = '';

    switch (pathway) {
        case 'alcohol':
            know =
                'Cutting down on alcohol can help your mood, memory and quality of sleep, and can also help with weight management.';
            break;
        case 'smoking':
            know =
                'Quitting smoking can even improve your senses of smell and taste - this is because tobacco contains chemicals which can dull your taste buds.';
            break;
        case 'weight':
            know =
                'Managing even just 5% of your total body weight can lead to health benefits, such as improvements in blood pressure, blood cholesterol, and blood sugars.';
            break;
        default:
            // activity
            know =
                'Physical activity is shown to reduce the risk of chronic conditions such as heart disease, diabetes, depression, and high blood pressure.';
    }

    return (
        <div className="flex flex-col gap-3">
            <div className="h-auto">
                <Illustration type={`bct-${pathway}`} classes="w-full object-center md:min-h-[106px]" />
            </div>
            <div className="flex flex-col gap-4 p-6 lg:px-12">
                <Text>Step 3 of 3</Text>
                <Heading h1>Based on what you&apos;ve told me, here are some techniques that could help</Heading>

                <Text body>
                    Nice job, you're nearly there! Our experts recommend these techniques based on what has worked for
                    others facing the same barrier as you. Choose the one you like most and I’ll help you get started!
                </Text>

                <InfoCard
                    classes="mb-4"
                    childrenComponent={
                        <div className="flex flex-col gap-2 pl-2">
                            <Heading h3>Did you know?</Heading>
                            <Text body2 classes="normal-case">
                                {know}
                            </Text>
                        </div>
                    }
                />

                <Field
                    name="bct"
                    label="Select the 1 technique you think will help you the most:"
                    input="radio"
                    isRequired
                    classes="font-normal"
                    inputOptions={{
                        options,
                    }}
                />
            </div>
        </div>
    );
}

export default TechniqueForm;
